<script>
export default {
  name: "MisericordiaView"
}
</script>

<template>
  <h1 style="color: #fb4242">La Misericordia di San Francesco d'Assisi</h1>
  <hr class="linea-ancore-primo-livello">
  
  <div class="misericordia-intro">
    <p>
      La misericordia è il cuore del messaggio di San Francesco. Non è semplicemente una virtù, 
      ma un'attitudine di vita che si esprime nell'amore concreto verso il prossimo e tutte le creature. 
      Francesco visse la misericordia come risposta all'amore infinito di Dio, trasformando il suo cuore 
      e la sua ricerca di pace in un servizio di compassione universale.
    </p>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <div class="quote-section">
    <h2 style="color: #fb4242">Il Messaggio di Francesco</h2>
    <div class="quote-box">
      <p style="color: white; font-size: 1.3em; font-style: italic;">
        "Dov'è carità e sapienza, ivi non è timore né ignoranza."
      </p>
      <p style="color: #9f9d9d; margin-top: 15px;">- San Francesco d'Assisi</p>
    </div>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <div class="gallery-section">
    <h2 style="color: #fb4242">Galleria della Misericordia</h2>
    <p style="color: #dcdbdb; margin-bottom: 40px; font-size: 1.1em;">
      La visione francescana della misericordia si manifesta nell'amore universale verso tutte le creature. 
      Queste immagini rappresentano il tema della compassione e della riconciliazione nel percorso spirituale di San Francesco.
    </p>
    
    <div class="gallery-grid">
      <div class="gallery-item">
        <img src="@/assets/Misericordia1.jpg" alt="Misericordia 1 - La compassione di Francesco" />
        <div class="gallery-caption">
          <h4>La Compassione Universale</h4>
          <p>Francesco estende il suo amore misericordioso a tutte le creature, vedendo in ognuna un riflesso dell'amore divino.</p>
        </div>
      </div>
      
      <div class="gallery-item">
        <img src="@/assets/Misericordia2.jpg" alt="Misericordia 2 - La riconciliazione" />
        <div class="gallery-caption">
          <h4>La Riconciliazione</h4>
          <p>La misericordia costruisce ponti tra i cuori. Francesco fu un grande riconciliatore, portando pace dove c'era conflitto.</p>
        </div>
      </div>
      
      <div class="gallery-item">
        <img src="@/assets/Misericordia3.jpg" alt="Misericordia 3 - L'amore che trasforma" />
        <div class="gallery-caption">
          <h4>L'Amore che Trasforma</h4>
          <p>La misericordia è un amore che perdona, accoglie e trasforma. Francesco lo visse come risposta all'amore infinito di Dio.</p>
        </div>
      </div>
    </div>
  </div>
  
  <div class="arrow-spacer">
    <i class="fa fa-arrow-down"></i>
  </div>
  
  <div class="resources-section">
    <h2 style="color: #fb4242; font-size: 2em;">Materiali di Approfondimento</h2>
    <p style="color: #dcdbdb; margin-bottom: 50px; font-size: 1.1em;">
      Esplora le nostre risorse didattiche per approfondire il tema della misericordia
    </p>
    
    <div class="resources-grid">
      <div class="resource-card pdf-card">
        <div class="resource-preview">
          <img src="@/assets/preview_conflitto.png" alt="Preview Misericordia" />
          <div class="preview-overlay">
            <i class="fa fa-file-pdf-o"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Risolvere Conflitti</h3>
          <h4>Guida Didattica</h4>
          <p>Una risorsa completa su come risolvere i conflitti seguendo l'insegnamento di San Francesco sulla riconciliazione e la pace</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-graduation-cap"></i> Didattico</span>
          </div>
        </div> 
        <div class="resource-actions">
          <a href="/Risolvere_conflitti.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Risolvere_conflitti.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card pdf-card">
        <div class="resource-preview">
          <img src="@/assets/preview_francescoassisi.png" alt="Preview San Francesco" />
          <div class="preview-overlay">
            <i class="fa fa-file-pdf-o"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>San Francesco d'Assisi</h3>
          <h4>Biografia Illustrata</h4>
          <p>Una presentazione dettagliata della vita di San Francesco con focus sulla sua esperienza della misericordia divina</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-book"></i> Biografia</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/san_francesco_dassisi.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/san_francesco_dassisi.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card pdf-card">
        <div class="resource-preview">
          <img src="@/assets/preview_misericordia.png" alt="Preview Cantico" />
          <div class="preview-overlay">
            <i class="fa fa-music"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Laudato Sii Signore</h3>
          <h4>Il Cantico del Sole</h4>
          <p>Il celebre Cantico di San Francesco che esprime la sua visione di comunione universale e amore verso tutte le creature</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-music"></i> Letterario</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Laudatosimiosignore.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Laudatosimiosignore.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card activity-card">
        <div class="resource-preview">
          <img src="@/assets/dadomisericordia.png" alt="Preview Dado Misericordia" />
          <div class="preview-overlay">
            <i class="fa fa-gamepad"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Gioco del Dado</h3>
          <h4>Attività Interattiva</h4>
          <p>Un'attività ludica per esplorare i diversi aspetti della misericordia attraverso il gioco educativo</p>
          <div class="resource-meta">
            <span><i class="fa fa-gamepad"></i> Interattivo</span>
            <span><i class="fa fa-graduation-cap"></i> Didattico</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/dadomisericordia.png" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/dadomisericordia.png" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card worksheet-card">
        <div class="resource-preview">
          <img src="@/assets/preview_abbinareleparole.png" alt="Preview Attività" />
          <div class="preview-overlay">
            <i class="fa fa-pencil"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Abbinare le Parole</h3>
          <h4>Esercizio Didattico</h4>
          <p>Un esercizio di abbinamento per associare concetti chiave della misericordia con i loro significati</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-graduation-cap"></i> Esercizio</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/abbinaleparole.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/abbinaleparole.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card bookmark-card">
        <div class="resource-preview">
          <img src="@/assets/preview_segnalibro_missericordia.png" alt="Segnalibro Misericordia" class="preview-image" />
          <div class="preview-overlay">
            <i class="fa fa-bookmark"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>Segnalibro</h3>
          <h4>Risorsa Stampabile</h4>
          <p>Un elegante segnalibro da stampare per accompagnare la lettura degli insegnamenti sulla misericordia</p>
          <div class="resource-meta">
            <span><i class="fa fa-file-pdf-o"></i> PDF</span>
            <span><i class="fa fa-bookmark"></i> Stampabile</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Segnalibromissericordia.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Segnalibromissericordia.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
      
      <div class="resource-card pdf-card">
        <div class="resource-preview">
          <div class="placeholder-preview">
            <i class="fa fa-book"></i>
            <p>San Francesco ed il<br>Lupo</p>
          </div>
          <div class="preview-overlay">
            <i class="fa fa-book"></i>
          </div>
        </div>
        <div class="resource-content">
          <h3>San Francesco ed il Lupo</h3>
          <h4>Progetto Didattico</h4>
          <p>Un progetto che esplora la storia del lupo di Gubbio e il messaggio di riconciliazione di San Francesco attraverso la prospettiva di una classe intera</p>
          <div class="resource-meta">
            <span><i class="fa fa-book"></i> PDF</span>
            <span><i class="fa fa-graduation-cap"></i> Didattico</span>
          </div>
        </div>
        <div class="resource-actions">
          <a href="/Classe1C_Lupo.pdf" target="_blank" class="resource-button primary-button">
            <i class="fa fa-eye"></i> Visualizza
          </a>
          <a href="/Classe1C_Lupo.pdf" download class="resource-button secondary-button">
            <i class="fa fa-download"></i> Scarica
          </a>
        </div>
      </div>
    </div>
  </div>
  
  <div style="margin-top: 200px; height: 1px;"></div>
</template>

<style scoped>
hr.linea-ancore-primo-livello {
  width: 40%;
  border-top: 2px solid #eee;
  margin: 20px auto 40px auto;
}

.misericordia-intro {
  max-width: 800px;
  margin: 40px auto;
  padding: 30px;
  background: #181a1c;
  border-radius: 10px;
  font-size: 1.1em;
}

.arrow-spacer {
  margin: 60px 0;
  color: white;
  font-size: 1.5em;
  text-align: center;
}

.quote-section {
  margin: 60px auto;
  text-align: center;
}

.quote-section h2 {
  margin-bottom: 40px;
}

.quote-box {
  background: #181a1c;
  padding: 40px;
  border-radius: 10px;
  margin: 0 auto;
  max-width: 800px;
  border-left: 5px solid #fb4242;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.gallery-section {
  max-width: 1200px;
  margin: 80px auto;
  padding: 60px 20px;
}

.gallery-section h2 {
  text-align: center;
  margin-bottom: 20px;
}

.gallery-section > p {
  text-align: center;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.gallery-item {
  background: #181a1c;
  border-radius: 15px;
  overflow: hidden;
  transition: all 0.4s ease;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
}

.gallery-item:hover {
  transform: translateY(-15px);
  border-color: #fb4242;
  box-shadow: 0 20px 50px rgba(251, 66, 66, 0.3);
}

.gallery-item img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  transition: transform 0.4s ease, filter 0.4s ease;
}

.gallery-item:hover img {
  transform: scale(1.05);
  filter: brightness(0.9);
}

.gallery-caption {
  padding: 25px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.gallery-caption h4 {
  color: #fb4242;
  margin: 0 0 12px 0;
  font-size: 1.2em;
}

.gallery-caption p {
  color: #9f9d9d;
  margin: 0;
  line-height: 1.6;
  font-size: 0.95em;
}

.resources-section {
  max-width: 1400px;
  margin: 80px auto;
  padding: 60px 20px;
  background: linear-gradient(135deg, rgba(24, 26, 28, 0.8) 0%, rgba(31, 33, 35, 0.8) 100%);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.resources-section h2 {
  text-align: center;
  margin-bottom: 10px;
}

.resources-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin: 50px 0;
}

.resource-card {
  background: #1f2123;
  border-radius: 15px;
  padding: 0;
  transition: all 0.4s ease;
  overflow: hidden;
  border: 2px solid transparent;
  display: flex;
  flex-direction: column;
  position: relative;
}

.resource-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(90deg, #fb4242, #ff6b6b);
  transform: scaleX(0);
  transition: transform 0.4s ease;
  z-index: 2;
}

.resource-card:hover::before {
  transform: scaleX(1);
}

.resource-card:hover {
  transform: translateY(-15px);
  box-shadow: 0 20px 50px rgba(251, 66, 66, 0.4);
  border-color: #fb4242;
}

.pdf-card:hover { border-color: #ff6b6b; }
.activity-card:hover { border-color: #4ecdc4; }
.worksheet-card:hover { border-color: #ffd93d; }
.gallery-card:hover { border-color: #95e1d3; }
.bookmark-card:hover { border-color: #ff9999; }

.resource-preview {
  position: relative;
  width: 100%;
  height: 200px;
  overflow: hidden;
  background: #0d0e0f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resource-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease, filter 0.4s ease;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.resource-card:hover .resource-preview img {
  transform: scale(1.1);
  filter: brightness(0.7);
}

.preview-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(251, 66, 66, 0.8), rgba(251, 66, 66, 0.3));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.4s ease;
}

.resource-card:hover .preview-overlay {
  opacity: 1;
}

.preview-overlay i {
  font-size: 4em;
  color: white;
  transform: scale(0.5);
  transition: transform 0.4s ease;
}

.resource-card:hover .preview-overlay i {
  transform: scale(1);
}

.resource-content {
  padding: 30px;
  flex-grow: 1;
  text-align: center;
}

.resource-content h3 {
  color: #fb4242;
  font-size: 1.5em;
  margin: 0 0 5px 0;
  font-weight: bold;
}

.resource-content h4 {
  color: #dcdbdb;
  font-size: 1.1em;
  margin: 0 0 15px 0;
  font-weight: normal;
  opacity: 0.8;
}

.resource-content p {
  color: #9f9d9d;
  line-height: 1.7;
  margin: 15px 0;
  font-size: 0.95em;
}

.resource-meta {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.resource-meta span {
  color: #fb4242;
  font-size: 0.85em;
  padding: 5px 12px;
  background: rgba(251, 66, 66, 0.1);
  border-radius: 15px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.resource-actions {
  display: flex;
  gap: 0;
  width: 100%;
  border-top: 1px solid rgba(251, 66, 66, 0.1);
}

.resource-button {
  flex: 1;
  padding: 18px 20px;
  text-decoration: none;
  font-weight: bold;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  border: none;
  font-size: 1em;
  text-align: center;
}

.primary-button {
  background: #fb4242;
  color: white;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

.primary-button:hover {
  background: #ff5252;
  transform: scale(1.02);
}

.secondary-button {
  background: transparent;
  color: #fb4242;
}

.secondary-button:hover {
  background: rgba(251, 66, 66, 0.1);
  color: #ff5252;
}

.placeholder-preview {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(251, 66, 66, 0.1) 0%, rgba(251, 66, 66, 0.05) 100%);
  color: #fb4242;
}

.placeholder-preview i {
  font-size: 4em;
  margin-bottom: 10px;
  opacity: 0.7;
}

.placeholder-preview p {
  margin: 0;
  font-size: 0.9em;
  font-weight: 600;
  text-align: center;
  opacity: 0.6;
}

@media (max-width: 768px) {
  .gallery-grid {
    grid-template-columns: 1fr;
  }

  .gallery-item img {
    height: 250px;
  }

  .resources-grid {
    grid-template-columns: 1fr;
  }
  
  .resource-button {
    font-size: 0.9em;
    padding: 15px;
  }
  
  .resources-section {
    padding: 40px 15px;
  }
  
  .quote-box {
    padding: 30px;
  }

  .gallery-section {
    padding: 40px 15px;
  }
}
</style>

